import { useSpring } from '@react-spring/web';
const COLLAPSED_WIDTH = '4rem';
const EXPANDED_WIDTH = '17.5rem';
const SUBNAV_EXPANDED_WIDTH = '13.5rem';
const SPRING_CONFIG = {
    mass: 1,
    tension: 240,
    friction: 25
};
export const useNavigationWidths = (collapsed, leftNavCollapsed, subNavCollapsed) => {
    const widthMain = useSpring({
        width: collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH,
        config: SPRING_CONFIG
    });
    const widthLeftNav = useSpring({
        width: leftNavCollapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH,
        config: SPRING_CONFIG
    });
    const widthSubNav = useSpring({
        width: subNavCollapsed ? '0rem' : SUBNAV_EXPANDED_WIDTH,
        config: SPRING_CONFIG
    });
    return { widthMain, widthLeftNav, widthSubNav };
};
//# sourceMappingURL=useNavigationWidths.js.map